<template>
	<div>
		<greetings-header
			class="tw-mb-2"
			:session-name="sessionName"
			sub-title="Ayudanos a valorar los siguientes puestos."
		/>
		<job-evaluation-poll-progress class="tw-mb-2" :completed-count="selectedFactorIndex + 1" :size-count="factorsCount" />
		<job-selection-carousel class="tw-mb-6" :jobs="jobs" :selected-job="selectedJob"/>
		<job-factor-assignation
			class="tw-mb-10"
			:selected-job="selectedJob"
			@jobChange="onJobChange"
		/>
		<div class="tw-mb-10 tw-text-center">
			<v-btn
				class="custom-button black tw-w-40"
				color="primary"
				style="margin-right: 20px !important;"
				@click="goPrevJob"
				:disabled="!hasPrev"
			>
				Atrás
			</v-btn>
			<v-btn
				class="custom-button tw-w-40 tw-mr-4"
				color="primary"
				style="margin-right: 20px !important;"
				@click="saveInformation"
			>
				{{ jobsAreCompleted ? 'Enviar' : 'Guardar' }}
			</v-btn>
			<v-btn
				class="custom-button tw-w-40"
				color="primary"
				:disabled="!hasNext || !selectedJob.completed"
				@click="goNextJob"
			>
				Siguiente Puesto
			</v-btn>
		</div>
	</div>
</template>

<script>
import GreetingsHeader from '@/modules/shared/components/business/GreetingsHeader';
import JobEvaluationPollProgress
	from '@/modules/polls/components/custom/JobEvaluationPollPage/JobEvaluationPollProgress';
import JobSelectionCarousel from '@/modules/polls/components/custom/JobEvaluationPollPage/JobSelectionCarousel';
import JobFactorAssignation from '@/modules/polls/components/custom/JobEvaluationPollPage/JobFactorAssignation';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { filter, pathOr, propEq, length, prop, has } from 'ramda';
import { getFactorRateSum, jobIsCompletedFilled } from '../utils/custom/job-evaluation';

const { getLocalData } = helper;

export default {
	name: 'JobEvaluationPollPage',
	components: {
		JobFactorAssignation,
		JobSelectionCarousel,
		JobEvaluationPollProgress,
		GreetingsHeader,
	},
	data() {
		return {
			selectedFactorIndex: 0,
			surveyId: null,
		};
	},
	mounted() {
		const { id } = this.$route.params;
		this.surveyId = id;
		this.$store.dispatch('polls/getSurveyData', { surveyId: this.surveyId })
			.then(() => {
				this.updateSelectedFactor(0);
			});
	},
	computed: {
		...mapState('polls', {
			jobs: pathOr([], ['custom', 'jobEvaluationPoll', 'jobs']),
			selectedJob: pathOr([], ['custom', 'jobEvaluationPoll', 'selectedJob']),
		}),
		jobsAreCompleted() {
			return length(filter(propEq('completed', true), this.jobs)) === length(this.jobs);
		},
		factorsCount() {
			return length(this.jobs);
		},
		hasPrev() {
			return has(this.selectedFactorIndex - 1, this.jobs);
		},
		hasNext() {
			return has(this.selectedFactorIndex + 1, this.jobs);
		},
		sessionName() {
			const { name, lastName } = getLocalData('praktiko-user');
			return `${name} ${lastName}`;
		},
	},
	methods: {
		updateSelectedFactor(index) {
			this.selectedFactorIndex = index;
			this.$store.dispatch('polls/updateSelectedJob', prop(index, this.jobs));
		},
		onJobChange(job) {
			const jobIsCompleted = jobIsCompletedFilled(job.factors);
			const jobDegreeRate = getFactorRateSum(job.factors);

			this.$store.dispatch('polls/updateJob', {
				index: this.selectedFactorIndex,
				job: { ...job, completed: jobIsCompleted, rate: jobDegreeRate },
			});
		},
		goNextJob() {
			this.updateSelectedFactor(this.selectedFactorIndex + 1);
		},
		goPrevJob() {
			this.updateSelectedFactor(this.selectedFactorIndex - 1);
		},
		saveInformation() {
			this.$store.dispatch('polls/saveSurveyData', { isFinalSave: this.jobsAreCompleted })
				.then(() => {
					if (this.jobsAreCompleted) {
						this.goTo('survey-list');
					}
				});
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/polls/pages/JobEvaluationPollPage.vue